import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';
import EmptyPagePlaceholder from '../../common/components/EmptyPagePlaceholder';
import TrumpeterButterflyImage from '../../assets/images/trumpeter_butterfly.png';
import { RoutePaths } from '../../routes/AppRoutes';
import { ProductFragment } from '../products';
import ProductNameOptimizationDialog from '../naming-wizard/ProductNameOptimizationDialog';
import ProductNameToOptimizeListItem from './ProductNameToOptimizeListItem';

interface ProductNameToOptimizeListProps {
  products: ProductFragment[];
}

export default function ProductNameToOptimizeList({ products }: ProductNameToOptimizeListProps): React.JSX.Element {
  const { t } = useTranslation(['products']);
  const [productToOptimize, setProductToOptimize] = useState<ProductFragment>();

  if (!products.length) {
    return (
      <EmptyPagePlaceholder
        title={t('products:name_optimization.empty')}
        imageSrc={TrumpeterButterflyImage}
        sx={{ pt: 0 }}
      />
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {products.map((product) => (
        <ProductNameToOptimizeListItem
          key={product.id}
          product={product}
          onOptimize={() => setProductToOptimize(product)}
        />
      ))}
      {productToOptimize && (
        <ProductNameOptimizationDialog
          product={productToOptimize}
          productLink={generatePath(RoutePaths.PRODUCT, { productSku: `${productToOptimize.sku}`, companyId: productToOptimize.company_id })}
          onClose={() => setProductToOptimize(undefined)}
        />
      )}
    </Box>
  );
}
